import React from "react";
import Banner from "../components/Banner/Banner";
import Coinstable from "../components/Coinstable";

const Home = () => {
  return (
    <>
      <Banner />
      <Coinstable />
    </>
  );
};

export default Home;
